import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { bookInfo } from '../../data/bookData';
import { FiArrowRight, FiBookOpen, FiList } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const WorldCta = () => (
  <section className="py-24 bg-brand-dark border-t border-white/5 relative overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-accent/5 via-transparent to-transparent"></div>
    <div className="max-w-3xl mx-auto px-6 text-center relative z-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-4">
          Ready to Enter This World?
        </h2>
        <p className="text-gray-400 mb-10 text-lg">
          Five centuries. Eight worlds. One signal that changes everything.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/story"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-brand-accent text-brand-dark rounded-lg font-bold hover:bg-brand-accentHover transition-colors"
          >
            <SafeIcon icon={FiBookOpen} /> Read the Full Story
          </Link>
          <Link
            to="/chapters"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/5 text-white border border-white/20 rounded-lg font-bold hover:bg-white/10 transition-colors"
          >
            <SafeIcon icon={FiList} /> Explore the Chapters
          </Link>
          <a
            href={bookInfo.links.amazon.kindle}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/5 text-white border border-white/20 rounded-lg font-bold hover:bg-white/10 transition-colors"
          >
            Get the Book <SafeIcon icon={FiArrowRight} />
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);

export default WorldCta;